module.exports = __webpack_public_path__ + "img/pleisure_bodyimage07.3e06fd21.jpg";